import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { TranslateService } from 'src/app/services/translate.service';
import { VersionService } from 'src/app/services/version.service';
import { UtilityService } from 'src/app/util/utility.service';
import { environment } from 'src/environments/environment';
import communityQuestion from 'src/assets/json/communityQuestion.json';
import communityQuestionHindi from 'src/assets/json/communityQuestionHindi.json';

@Component({
  selector: 'app-slide4',
  templateUrl: './slide4.component.html',
  styleUrls: ['./slide4.component.scss'],
})
export class Slide4Component implements OnInit {
  @Input() invitee: any;
  @Input() session: any;
  bloodDonation: boolean = false;
  utilityService: UtilityService = new UtilityService();
  objectKeys = Object.keys;
  tncAccepted: boolean = true;
  envName: string = environment.envName;
  version: number = VersionService.version;
  questions = communityQuestion;
  answers: any = {};

  constructor(public trans: TranslateService,
    public auth: AuthService,
    public versionService: VersionService,


  ) { }

  ngOnInit() {
    if (this.trans.language === 'hi') {
      this.questions = communityQuestionHindi;
    } else {
      this.questions = communityQuestion;
    }
  }

  updateAnswer(questionId: string, option: string, checked: boolean) {
    if (!this.answers[questionId]) this.answers[questionId] = [];
    if (checked) {
      this.answers[questionId].push(option);
    } else {
      this.answers[questionId] = this.answers[questionId].filter((x: string) => x !== option);
    }
    this.auth.loggedInEmployee.user.user_pd.metaData = this.answers;
    console.log(this.answers);
  }
  updateTextAnswer(questionId: string, value: string) {
    this.answers[questionId] = value;
  }
}
